import { LoadingIcon } from '../../components/loading/LoadingIcon';
import React, { Suspense } from 'react';
import styled from 'styled-components';

export const LoadingSuspense: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  return <Suspense fallback={<LoadingContainer />}>{children}</Suspense>;
};

const LoadingContainer: React.FC = () => {
  return (
    <Container>
      <LoadingIcon />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-grow: 1;
`;
